// ⚠️ 파일명 `zz.*` — registerPlugins(src/@core/utils/plugins.js)가
// 파일명 ASCII 정렬 순으로 플러그인을 등록하기 때문에, unhead가
// Vuetify(src/plugins/vuetify/)보다 뒤에 초기화되도록 `z` 접두사를 사용.
// 이름을 `unhead.js` 등 vuetify 앞으로 바꾸면 Vuetify가 런타임에
// <head>에 주입하는 theme CSS 변수가 적용되지 않아 primary 색상이
// 검정으로 보이는 이슈 재현됨.
import { createHead } from '@unhead/vue/client';

export default function (app) {
  app.use(createHead());
}
